export enum SqlAggregateFunctionType {
  None = 0,
  SUM = 1,
  AVG = 2,
  MIN = 3,
  MAX = 4,
  COUNT = 5,
}
